// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3H4TZ","info":"UpdateTermsInfo_info__1wnwx"};